import React from 'react';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import { hideAlert } from '../redux/alert/alertReducer';

const AlertBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const { open, message, type, duration } = useAppSelector((state) => state.alert);

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    dispatch(hideAlert());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={handleClose}
        severity={type as AlertColor}
        sx={{ width: '100%' }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default AlertBar; 